import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper">
      <div className="text-center">
        <p className="mb-3 font-mono text-[13px] text-ink-3">404</p>
        <h1 className="mb-3 text-3xl">This page is not here</h1>
        <p className="mb-6 text-[15px] text-ink-2">The link may be old, or the page has moved.</p>
        <a
          href="/"
          className="inline-flex rounded-full bg-ink px-5 py-2.5 text-[14px] font-medium text-paper-raised transition-colors hover:bg-ink/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-signal focus-visible:ring-offset-2"
        >
          Go to Mindfull
        </a>
      </div>
    </div>
  );
};

export default NotFound;
